<template>
	<div class="expertDesc">
		<div class="expertContent">
			<!-- 左侧信息描述 -->
			<div class="leftDescTitle">
				<!-- 描述主体 -->
				<div v-for="(item,index) in topInfoArr" :key="item.id">
					<div class="descContent" v-show="item.id == topInfoIndex">
						<!-- 标题组1 -->
						<div class="title_01 m-4">
							<h3 style="font-weight: bold;">{{item.unitName}}</h3>
							<p>{{item.post}}</p>
						</div>
						<!-- 标题组2 -->
						<div class="title_02 m-4" style="position: relative;top:5px">
							<h3 class="font-weight-bold">{{item.name}}</h3>
							<p>{{item.position}}</p>
						</div>
						<!-- 标题组3 -->
						<div class="m-4 pt-5">
							<div style="font-size: 15px;" v-html="item.introduce">
							</div>
						</div>
					</div>
				</div>
				<!-- 下方tab切换 -->
				<div class="bottomTab">
					<div class="expertImgCard d-flex"
					v-for="(item,index) in topInfoArr" :key="item.id" style="justify-content: center;align-items: center;position: relative;"
					@click="tabClick(item,index)" :class="{'borderOut':topInfoIndex == item.id }" >
						<img :src="item.logoUrl" width="140" height="140" style="position: absolute;bottom: 0;">
					</div>
				</div>
			</div>
			<!-- 右侧人物图像 -->
			<div class="rightExpert">
				<img :src="rightImgUrl" width="320" height="642" v-show="rightImgUrl">
			</div>
		</div>
		<!-- 核心成员模块 -->
		<div class="teamCore">
			<ModuleTitle titleName="核心成员" titleEngName="Team Core" class="pt-4"></ModuleTitle>
			<div class="d-flex flex-wrap mb-4" style="justify-content: space-between;">
				<div class="pt-4" v-for="(item,index) in bottomInfoArr" @click="teamDialogOpen(index)" style="cursor: pointer;">
					<div style="width:240px;height:300px; justify-content: center;align-items: center;"
					 class="border mb-4 text-center position-relative">
						<img :src="item.url" width="140" height="280" style="position: absolute;bottom: 0;left:50px;">
					</div>
					<!-- 姓名职位 -->
					<div class="pt-2 text-center" style="line-height: 15px;">
						<p class="font-weight-bold" style="color: #333333;font-size:20px;">{{item.name}}</p>
						<span style="color: #666;">{{item.position}}</span>
					</div>
				</div>
			</div>
			<!-- 成员信息弹框 -->
			<div>
				<el-dialog
				  title="成员信息"
				  v-model="teamDialog"
				  width="620px"
				  center>
				  <div class="d-flex">
					  <div style="width:600px;">
						  <el-descriptions
							direction="vertical"
							:column="1"
							border
						  >
							<el-descriptions-item label="姓名">{{dialogInfo.name}}</el-descriptions-item>
							<el-descriptions-item label="职位">{{dialogInfo.position}}</el-descriptions-item>
							<el-descriptions-item label="成员领域" :span="2">{{dialogInfo.post}}</el-descriptions-item>
							<el-descriptions-item label="成员介绍">
								<div v-html="dialogInfo.note"></div>
							</el-descriptions-item>
						  </el-descriptions>
					  </div>
				  </div>
				</el-dialog>
			</div>
		</div>
		<!-- 公共底部 -->
		<Footer></Footer>
	</div>
</template>

<script>
	import ModuleTitle from '@/components/moduleTitle/moduleTitle.vue'
	import Footer from '@/components/footer/footer.vue'
	export default {
		name: 'Home',
		components: {
			ModuleTitle,
			Footer
		},
		data() {
			return {
				show:true,
				topInfoIndex:0,
				teamDialog:false,
				rightImgUrl:'',
				// 上部分四个
				topInfoArr:[],
				// 下部分十个
				bottomInfoArr:[],
				// 弹窗信息
				dialogIndex:0,
				dialogInfo:{}
			}
		},
		mounted() {
			this.topInfoIndex = this.$route.query.index
			this.getExpert()
			this.getBottomExpert()
		},
		methods: {
			tabClick(item,index){
				let vm = this
				vm.topInfoIndex = item.id
				this.axios.get('/api/expert/findUrlById/'+vm.topInfoIndex).then(res => {
					vm.rightImgUrl = res.data.data
				})
				vm.show = false
			},
			// 获取上半部分
			getExpert(){
				let vm = this
				this.axios.get('/api/expert/findUrlById/'+vm.topInfoIndex).then(res => {
					vm.rightImgUrl = res.data.data
				})
				this.axios.get('/api/expert/findTopExpert').then(res => {
					vm.topInfoArr = res.data.data
				})
			},
			// 获取下半部分
			getBottomExpert(){
				let vm = this
				this.axios.get('/api/expert/findAllByPage',{
					params:{
						currPage:1,
						everySize:10
					}
				}).then(res => {
					vm.bottomInfoArr = res.data.data.experts
					console.log(res.data)
				})
			},
			teamDialogOpen(index){
				let vm = this
				vm.teamDialog = true
				vm.dialogIndex = index
				vm.dialogInfo = vm.bottomInfoArr[index]
			}
		},
	}
</script>
<style scoped>
	.expertDesc{
		width: 100%;
		height:700px;
		background: url(../../assets/img/peopleDescBg.jpg) no-repeat;
	}
	.expertDesc .expertContent{
		width: 1200px;
		height: 700px;
		margin: 0 auto;
		display: flex;
		position: relative;
	}
	.expertDesc .expertContent .leftDescTitle{
		width:800px;
		height: 700px;
	}
	.expertDesc .expertContent .leftDescTitle .descContent{
		width: 700px;
		height: 400px;
		margin: 0 auto;
		margin-top:100px;
		color: #fff;
	}
	.expertDesc .expertContent .rightExpert{
		width: 330px;
		height: 700px;
		margin-left:70px;
		position: relative;
	}
	.expertDesc .expertContent .rightExpert img{
		position: absolute;
		bottom: 0;
	}
	.expertDesc .expertContent .leftDescTitle .bottomTab{
		width: 800px;
		height: 150px;
		margin-left:70px;
		display: flex;
	}
	/* 切换图片 */
	.borderOut{
		border: 4px solid #85FFBD;
	}
	/* 人物缩略图卡片 */
	.expertDesc .expertContent .leftDescTitle .bottomTab .expertImgCard{
		width:160px;
		height: 160px;
		background-color: #293952;
		margin-right:20px;
	}
	/* 核心成员模块 */
	.teamCore{
		width: 1200px;
		min-height: 500px;
		margin: 0 auto;
	}
</style>
